import { useEffect, useState, useContext } from 'react';
// @mui
import { alpha, useTheme } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar } from '@mui/material';
// components
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from "@tanstack/react-query";
import { PATH_DASHBOARD,PATH_MANAGEMENT } from '../../../routes/paths';
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
import useAuth from '../../../hooks/useAuth';
import { useCurrentUser } from "../../../contexts/CurrentUserProvider"
import { GetUser } from '../../../services';

export default function AccountPopover() {
  const { t, i18n  } = useTranslation();
  // const {logout, user} = useAuth()
  const [open, setOpen] = useState(null);
const {user, logout} = useAuth();
const isAdminOrSupporter = user.roles.some(role =>
  ['admin', 'supporter'].includes(role.name)
);

const MENU_OPTIONS = isAdminOrSupporter
  ? [
      {
        label: t('homePage'),
        linkTo: '/dashboard',
      },
      {
        label: t('Profile'),
        linkTo: PATH_DASHBOARD.user.account,
      },
      {
        label: t('Settings'),
        linkTo: PATH_MANAGEMENT.management.setting.root,
      },
    ]
  : [];
  
  const [profile, setPro] = useState();
  useEffect(() => {
    setPro(user)
  }, [profile, user]);
  const Logouts = () => {
    // document.location.reload('/login');
    logout();
    localStorage.clear();
  };
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >        
      <Avatar src={''} alt={profile?.first_name} />
        {/* <Avatar src={profile?.avatar ? profile?.avatar : userinfo?.avatar} alt={profile?.first_name} /> */}
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        

     {isAdminOrSupporter &&    <Divider sx={{ borderStyle: 'dashed' }} />}

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} to={option.linkTo} component={RouterLink} onClick={handleClose}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

     {isAdminOrSupporter &&    <Divider sx={{ borderStyle: 'dashed' }} />}

        <MenuItem sx={{ m: 1 }} onClick={Logouts}>
          
          {t('Logout')}
        </MenuItem>
      </MenuPopover>
    </>
  );
}
